import React, { useState, useEffect } from "react";
import Header from "../components/Header";
import LoginScreen from "../components/LoginScreen";
import OrderForm from "../components/OrderForm";
import OrderList from "../components/OrderList";
import Contacts from "../components/Contacts";
import BeerRainButton from "../components/BeerRainButton";
import ResetButton from "../components/ResetButton";
import { setLanguage } from "../utils/i18n";
import { getSession, login, logout } from "../utils/auth";
import "../index.css";

export default function HomePage() {
  const [lang, setLang] = useState("lt");
  const [session, setSession] = useState(() => getSession());
  const [orders, setOrders] = useState([]);

  const toggleLang = () => {
    setLang(prev => (prev === "lt" ? "en" : "lt"));
  };

  const fetchOrders = async () => {
    const res = await fetch("https://worker.kebatic.org/orders");
    if (res.ok) setOrders(await res.json());
  };

  useEffect(() => {
    if (session) fetchOrders();
  }, [session]);

  useEffect(() => {
    setLanguage(lang);
  }, [lang]);

  const handleLogin = (name, password) => {
    if (!login(name, password)) return false;
    setSession(getSession());
    return true;
  };

  const handleLogout = () => {
    logout();
    setSession(null);
    setOrders([]);
  };

  const handleOrderSubmit = async (order) => {
    await fetch("https://worker.kebatic.org/order", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(order),
    });
    await fetchOrders();
  };

  if (!session) {
    return (
      <LoginScreen onLogin={handleLogin} lang={lang} onToggleLang={toggleLang} />
    );
  }

  return (
    <div className="page">
      <div className="container container--app">
        <Header
          onToggleLang={toggleLang}
          lang={lang}
          userName={session.name}
          onLogout={handleLogout}
        />
        <div className="app-layout">
          <div className="app-main">
            <OrderForm onSubmit={handleOrderSubmit} lang={lang} userName={session.name} />
            <ResetButton onReset={fetchOrders} lang={lang} />
          </div>
          <div className="app-aside">
            <OrderList orders={orders} onReload={fetchOrders} lang={lang} />
          </div>
        </div>
        <Contacts lang={lang} />
        <BeerRainButton />
      </div>
    </div>
  );
}
